
import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { map, catchError } from 'rxjs/operators';
import { from, of } from 'rxjs';
import { UserService } from '../app/secure/_services/user/user.service';

export const coordinatorGuard: CanActivateFn = (_route, state) => {
  const router = inject(Router);
  const userService = inject(UserService);
  
  // Llamar a loadEmployeeInformation y esperar su resultado
  return from(userService.loadEmployeeInformation()).pipe(
    map((user) => {
      const isAuthenticated = !!user;
      const isCoordinator = user?.roles?.includes('BusManagement_Coordinators');
      const isGovernance = user?.roles?.includes('BusManagement_Governance');

      if (isAuthenticated && (isCoordinator || isGovernance)) {
        return true; // Permitir acceso
      } else {
        router.navigate(['/secure/unauthorized'], { queryParams: { returnUrl: state.url } });
        return false; // Redirigir a la página de acceso no autorizado
      }
    }),
    catchError((err) => {
      console.error('Error in CoordinatorGuard:', err);
      router.navigate(['/secure/unauthorized'], { queryParams: { returnUrl: state.url } });
      return of(false); // Redirigir en caso de error
    })
  );
};